// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit';
import * as rms from "./api/rms";
import * as acs from "./api/acs";
import {gamIds} from "../../pages/dashboard/globalsettings/mcm/constants";
// api


// thunks
export const fetchChildPublishersData = createAsyncThunk('mcm/fetchChildPublishersData', async requestData => {
    let result = [];
    for(let i=0; i < gamIds.length; i++) {
        const response = await acs.getChildPublishersRequest({dfpNetworkId: gamIds[i]});
        if(response.data) {
            response.data.forEach((item) => {
                item.parentNetworkId = gamIds[i];
            });
        }
        result = result.concat(response.data);
    }
    result = result.filter(function (el) {
        return el != null;
    });
    return result;
});

export const fetchMcmAccountsData = createAsyncThunk('mcm/fetchMcmAccountsData', async requestData => {
    const response = await rms.getMcmAccountsRequest();
    return response.data
});

export const saveMcmAccount = createAsyncThunk('mcm/saveMcmAccount', async requestData => {
    const response = await rms.saveMcmAccountRequest(requestData);
    return response.data
});